export const isEmpty = (obj) => {
  if (obj === undefined || obj === null) {
    return true;
  }
  // Bei Strings prüfen wir, ob sie leer, nur aus Leerzeichen bestehen oder "[]" bzw. "{}" enthalten.
  if (typeof obj === "string") {
    const trimmed = obj.trim();
    return trimmed.length === 0 || trimmed === "[]" || trimmed === "{}";
  }
  // Leere Arrays prüfen wir explizit.
  if (Array.isArray(obj)) {
    return obj.length === 0;
  }
  // Primitive Werte, die keine Strings sind, werden als nicht leer betrachtet.
  if (typeof obj !== "object" && typeof obj !== "function") {
    return false;
  }
  // Für Objekte und Funktionen wird geprüft, ob sie eigene, aufzählbare Eigenschaften haben.
  return Object.keys(obj).length === 0;
};
